
const getEmptyValuesKeys = (obj: Record<string, any>): string => {
  if (!obj || typeof obj !== 'object') {
    return ''
  }

  const falsyKeys = Object.keys(obj).filter(key => !obj[key])
  return falsyKeys.join(', ')
}

export {
  getEmptyValuesKeys,
}